module.exports = __webpack_public_path__ + "img/AssignMembersImg.083f0834.png";